module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('van-tabs', {
    staticClass: "active-tab",
    attrs: {
      "animated": "",
      "sticky": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.activeTab), function(item, index) {
    return _c('van-tab', {
      key: index,
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [(item.num > 0) ? _c('span', {
            staticClass: "active-tab-num"
          }, [_vm._v(_vm._s(item.num))]) : _vm._e(), _vm._v(_vm._s(item.name) + " ")]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), (item.name == '动态') ? _c('div', [_c('div', {
      staticClass: "acitve-items"
    }, [_c('div', {
      staticClass: "active-items-title-read"
    }, [_c('div', {
      staticClass: "active-item-title"
    }, [_vm._v("2020年全国啦啦操公开赛日程安排及通知公告")]), _vm._v(" "), _c('div', {
      staticClass: "active-itme-read"
    }, [_vm._v("211阅读")])]), _vm._v(" "), _c('div', {
      staticClass: "active-item-pics"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/activity/pic-logo1@2x.png"),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "video-items"
    }, [_c('div', {
      staticClass: "active-item-title"
    }, [_vm._v("首届中国啦啦操文化节视频直播")]), _vm._v(" "), _c('div', {
      staticClass: "video-box"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/activity/pic-logo1@2x.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "video-bottom"
    }, [_c('span', [_vm._v("2019总决赛")]), _vm._v(" "), _c('span', [_vm._v("235432人阅读")])])]), _vm._v(" "), _c('div', {
      staticClass: "comments-items"
    }, [_c('div', {
      staticClass: "detail-header"
    }, [_c('div', {
      staticClass: "user-face"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/activity/pic-logo1@2x.png"),
        "alt": "",
        "srcset": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "user-info"
    }, [_c('div', {
      staticClass: "user-names"
    }, [_vm._v("冠顶饺")]), _vm._v(" "), _c('div', {
      staticClass: "look-info"
    }, [_vm._v(_vm._s(_vm._f("getTimeFormat")(1590123456)))])]), _vm._v(" "), _c('div', {
      staticClass: "bottom-right"
    })]), _vm._v(" "), _c('div', {
      staticClass: "activity-desc"
    }, [_vm._v("\n\t\t\t\t\t\t\t冠顶饺，象小船，故又名“金山三船饺\"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺\"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺\"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺\"！美餐，美味，美食！\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "activity-detail-bottom"
    }, [_c('div', {
      staticClass: "activity-place-box"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/activity/Shape@2x.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "activity-place"
    }, [_vm._v("南京新街口")])]), _vm._v(" "), _c('div', {
      staticClass: "release-time"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("getTimeFormat")(1590045030)))]), _c('span', [_c('img', {
      attrs: {
        "src": require("../../assets/images/activity/icon-comments.png"),
        "alt": ""
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "comments-detail"
    }, [_c('div', {
      staticClass: "comments-detail-top"
    }), _vm._v(" "), _c('div', {
      staticClass: "zan-box"
    }, [_c('span', {
      staticClass: "zan-num"
    }, [_vm._v("90赞")]), _vm._v(" "), _vm._l((4), function(i) {
      return _c('img', {
        key: i,
        staticClass: "user-zan-face",
        attrs: {
          "src": require("../../assets/images/activity/pic-logo1@2x.png"),
          "alt": ""
        }
      })
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "user-comments",
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_c('span', {
      staticClass: "comments-user-name"
    }, [_vm._v("GOODBAY")]), _vm._v(" :\n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "comments-user-desc"
    }, [_vm._v("怎么了")])]), _vm._v(" "), _c('div', {
      staticClass: "user-reply-comments",
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_c('span', {
      staticClass: "comments-user-name"
    }, [_vm._v("我")]), _vm._v(" 回复\n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "comments-user-name"
    }, [_vm._v("GOODBAY")]), _vm._v(" :\n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "comments-user-desc"
    }, [_vm._v("怎么了")]), _vm._v("很好\n\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (item.name == '图片') ? _c('div', [_vm._v("\n\t\t\t\t\t22\n\t\t\t\t")]) : _vm._e()])
  }), 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-detail-top"
  }, [_c('div', {
    staticClass: "top-info"
  }, [_c('div', {
    staticClass: "info-top-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/pic-logo1@2x.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-detail-title"
  }, [_vm._v("2020年全国啦啦操公开赛")]), _vm._v(" "), _c('div', {
    staticClass: "activity-detail-desc"
  }, [_vm._v("2019年亚太啦啦操公开赛于10月31日-11月4日在深圳信息职业技术学院体育馆隆重举行。")])]), _vm._v(" "), _c('div', {
    staticClass: "info-main-box"
  }, [_c('div', {
    staticClass: "activity-dynamic"
  }, [_c('span', [_vm._v("动态")]), _c('span', [_vm._v("111")]), _vm._v(" · "), _c('span', [_vm._v("互动")]), _c('span', [_vm._v("222")])]), _vm._v(" "), _c('div', {
    staticClass: "info-dynamic-items"
  }, [_c('div', {
    staticClass: "dynamic-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/pic-shuo-1@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("公告")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/pic-shuo-2@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("出场顺序")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/pic-shuo-3@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("图片|直播")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/pic-shuo-4@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("成绩查询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "info-bottom-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/activity/icon-shuo-notice@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1px",
      "height": "15px",
      "background": "rgba(0,0,0,1)",
      "opacity": "0.16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "start-immediately"
  }, [_vm._v("赛事马上开始咯~")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3382043e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/activity/ActivityList.vue
// module id = 1193
// module chunks = 0